import React from 'react';
import { connect } from 'react-redux';

import MessageList from '../components/MessageList';
import { checkConversation } from '../actions/index';

const mapStateToProps = (state) => ({
    messages: state.convo.messages,
    isFetching: state.convo.meta.isFetching,
    convoCode: state.convo.meta.convoCode
});

const Messages = connect(
    mapStateToProps
)(({ messages, isFetching, convoCode, dispatch }) => {
    console.log("hello", convoCode);
    dispatch(checkConversation(convoCode));
    if (isFetching) {
        return (
            <div>
                <p>IS FETCHING!!</p>
            </div>
        )
    }else{
        return <MessageList messages={messages}/>
    }
});

export default Messages;


// WEBPACK FOOTER //
// ./src/components/Messages.js